import { render, staticRenderFns } from "./ShopBrowser.vue?vue&type=template&id=956c8824&scoped=true&"
import script from "./ShopBrowser.vue?vue&type=script&lang=ts&"
export * from "./ShopBrowser.vue?vue&type=script&lang=ts&"
import style0 from "./ShopBrowser.vue?vue&type=style&index=0&id=956c8824&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956c8824",
  null
  
)

export default component.exports